module.exports = __webpack_public_path__ + "static/media/Caen-La-Mer.e30448d2.jpg";